document.addEventListener("DOMContentLoaded", function () {
  let model_filters = {
    Make: null,
    Model: null,
    Year: null,
  };

  let carPropertiesContainer = document.getElementById(
    "car-properties-container"
  );
  if (!carPropertiesContainer) return;

  if (document.body.classList.contains("template-index")) {
    carPropertiesContainer.addEventListener("change", function (event) {
      let targetElem = event.target;
      switch (targetElem.name) {
        case "properties[Make]":
          model_filters.Make = targetElem.value;
          break;
        case "properties[Model]":
          model_filters.Model = targetElem.value;
          break;
        case "properties[Year]":
          model_filters.Year = targetElem.value;
          break;
        default:
          return;
      }

      sessionStorage.setItem("model_filters", JSON.stringify(model_filters));
      //     console.log(event);
    });
    
  } else if (document.body.classList.contains("template-product")) {
    
    model_filters = JSON.parse(sessionStorage.getItem("model_filters"));
    let makeSelect = document.getElementById("make");
    let modelSelect = document.getElementById("models");
    let yearSelect = document.getElementById("modelyear");

    if(model_filters)
    makeSelect.value = model_filters.Make;
    makeSelect.dispatchEvent(new Event("change"));

    if(model_filters)
    modelSelect.value = model_filters.Model;
    modelSelect.dispatchEvent(new Event("change"));

    if(model_filters)
    yearSelect.value = model_filters.Year;
    yearSelect.dispatchEvent(new Event("change"));
    
  }
});
